<template>
  <app-layout title="Licenses">
    <template #header>
      <div class="flex items-center justify-between">
        <h1 class="text-3xl font-bold tracking-tight text-white">
          {{ __('Licenses') }}
        </h1>
        <div class="flex-shrink-0 flex items-center space-x-2">
<!--          <button class="relative inline-flex items-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm font-semibold text-gray-300 hover:bg-opacity-75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">-->
<!--            <component :is="giftIcon" class="h-5 w-5" aria-hidden="true" alt="gift"/>-->
<!--            {{ __('Gift') }}-->
<!--          </button>-->
          <inertia-link :href="route('order')" type="button" class="relative inline-flex items-center gap-x-1.5 rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">
            <PlusIcon class="-ml-0.5 h-5 w-5" aria-hidden="true" />
            {{ __('Purchase License') }}
          </inertia-link>
        </div>
      </div>
    </template>

    <!-- @translations {{ __('Package') }} -->
    <dynamic-table
        :resource="licenses"
        :name="__('Licenses')"
        :columns="['Title', 'Package', 'Status', 'Price', 'Next payment due', '#']"
    >
      <template v-slot="{ data: licenses, icons }">
        <tr v-for="license in licenses">
          <td class="text-sm font-semibold text-gray-400">{{ license.title }}</td>
          <td class="text-sm font-medium text-gray-500">
            {{ license.package.name }}
          </td>
          <td class="text-sm font-medium text-gray-500">
            <span class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20" v-if="license.status === 'ACTIVE'">{{ __(capitalizeFirstLetter(license.status)) }}</span>
            <!-- @translations {{ __('Expired') }}, {{ __('Cancelled') }}, {{ __('Suspended') }}, {{ __('Active') }}, {{ __('Pending') }} -->
            <span class="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20" v-else-if="['SUSPENDED', 'CANCELLED', 'EXPIRED'].includes(license.status)">{{ __(capitalizeFirstLetter(license.status)) }}</span>
            <span class="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-600/20" v-else>{{ __(capitalizeFirstLetter(license.status)) }}</span>
          </td>
          <td class="text-sm font-medium text-gray-500">{{ price(license.price) }}</td>
          <td class="text-sm font-medium text-gray-500">{{ date(license.expires_at) }}</td>
          <td class="column-actions flex items-center">
            <inertia-link class="flex items-center" :href="route('license.show', license)">
              <component :is="icons.edit" class="icon icon-edit"/>
            </inertia-link>
          </td>
        </tr>
      </template>
    </dynamic-table>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import DynamicTable from "@/Misc/Table/DynamicTable";
import {PlusIcon } from '@heroicons/vue/solid';
import Button from "@/Jetstream/Button";
import {defineComponent, h} from "vue";
export default {
  name: "List",
  components: {Button, DynamicTable, AppLayout, PlusIcon},
  props: ['licenses'],
  data() {
    return {
      giftIcon: defineComponent({
        render() {
          return h('svg', {
            width: '22',
            height: '22',
            viewBox: '0 0 22 22',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
          }, [
            h('path', {
              d: 'M11 6H6.5C5.83696 6 5.20107 5.73661 4.73223 5.26777C4.26339 4.79893 4 4.16304 4 3.5C4 2.83696 4.26339 2.20107 4.73223 1.73223C5.20107 1.26339 5.83696 1 6.5 1C10 1 11 6 11 6ZM11 6H15.5C16.163 6 16.7989 5.73661 17.2678 5.26777C17.7366 4.79893 18 4.16304 18 3.5C18 2.83696 17.7366 2.20107 17.2678 1.73223C16.7989 1.26339 16.163 1 15.5 1C12 1 11 6 11 6ZM11 6L11 21M1 13H21M1 9.2L1 17.8C1 18.9201 1 19.4802 1.21799 19.908C1.40973 20.2843 1.71569 20.5903 2.09202 20.782C2.51984 21 3.07989 21 4.2 21L17.8 21C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V9.2C21 8.0799 21 7.51984 20.782 7.09202C20.5903 6.7157 20.2843 6.40974 19.908 6.21799C19.4802 6 18.9201 6 17.8 6L4.2 6C3.0799 6 2.51984 6 2.09202 6.21799C1.7157 6.40973 1.40973 6.71569 1.21799 7.09202C1 7.51984 1 8.07989 1 9.2Z',
              stroke: 'currentColor',
              'stroke-width': '2',
              'stroke-linecap': 'round',
              'stroke-linejoin': 'round'
            })
          ]);
        }
      }),
    }
  },
}
</script>